import Rr from './none.js';
function qr(series) {
  return Rr(series).reverse();
}
export { qr as default };
//# sourceMappingURL=reverse.js.map
